import React, { useState, useEffect, Fragment } from 'react';
import clsx from "clsx";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Divider, Form, Input, Avatar, Spin, Steps } from "antd";
import styled from "styled-components";
import { editOpportunity, getOpportunity, getProgramById, setEditOpportunitiesData, toggleSpinner } from "../../redux/actions";
import StyledText from "../../components/StyledText";
import Button from "../../components/Button";
import { getLocalStorageItem } from "../../utils/utilities";
import goal1 from "../../assets/goal1.png";
import goal2 from "../../assets/goal2.png";
import goal3 from "../../assets/goal3.png";
import goal4 from "../../assets/goal4.png";
import goal5 from "../../assets/goal5.png";
import goal6 from "../../assets/goal6.png";
import goal7 from "../../assets/goal7.png";
import goal8 from "../../assets/goal8.png";
import goal9 from "../../assets/goal9.png";
import goal10 from "../../assets/goal10.png";
import goal11 from "../../assets/goal11.png";
import goal12 from "../../assets/goal12.png";
import goal13 from "../../assets/goal13.png";
import goal14 from "../../assets/goal14.png";
import goal15 from "../../assets/goal15.png";
import goal16 from "../../assets/goal16.png";
import goal17 from "../../assets/goal17.png";
import { opportunityDataSelector, editOpportunityData, toggleSpinnerSelector } from "../../redux/selectors";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import lightbulb from '../../assets/lightbulb.svg'

const outcomeUNSDGImages = [
    { key: 1, image: goal1 },
    { key: 2, image: goal2 },
    { key: 3, image: goal3 },
    { key: 4, image: goal4 },
    { key: 5, image: goal5 },
    { key: 6, image: goal6 },
    { key: 7, image: goal7 },
    { key: 8, image: goal8 },
    { key: 9, image: goal9 },
    { key: 10, image: goal10 },
    { key: 11, image: goal11 },
    { key: 12, image: goal12 },
    { key: 13, image: goal13 },
    { key: 14, image: goal14 },
    { key: 15, image: goal15 },
    { key: 16, image: goal16 },
    { key: 17, image: goal17 },
];

const { TextArea } = Input;

const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

const CharityImpactProgram = ({ className }) => {
    const baseClassName = clsx("charityImpactProgram", className);
    const intl = useIntl();
    const [textAreas, setTextAreas] = useState({});
    const [savedClicked, setSavedClicked] = useState(false);
    const opportunityData = useAppSelector(opportunityDataSelector) || {};
    const showSpinner = useAppSelector(toggleSpinnerSelector);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const programReviewDetails = JSON.parse(getLocalStorageItem('programReviewDetails') || '{}');
    const { opportunityId, programID } = programReviewDetails || {};
    const { opportunity } = opportunityData || {};

    const editOpp = useAppSelector(editOpportunityData) || {};

    const { opportunityID } = editOpp || {};

    useEffect(() => {
        if (opportunityID && !savedClicked) {
            dispatch(setEditOpportunitiesData(''))
            dispatch(toggleSpinner(false));
            navigate("/impact-maker/applications/create/beneficiaries");
        }
    }, [opportunityID]);

    useEffect(() => {
        if (opportunity?.opportunityName) {
            const initialValues = {};
            opportunity?.impactApproach?.objectives?.forEach(objective => {
                objective?.objectivesOutcome?.forEach(outcome => {
                    initialValues[`outcomeApproach-${objective.name}-${outcome.name}`] = outcome.outcomeApproach || '';
                });
            });
            form.setFieldsValue(initialValues);
            setTextAreas(initialValues)
        }
    }, [opportunity?.opportunityName]);

    useEffect(() => {
        if (opportunityId) {
            dispatch(getOpportunity(opportunityId));
        }
    }, [opportunityId]);

    useEffect(() => {
        if (programID) {
            document.documentElement.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            dispatch(getProgramById(programID));
        }
    }, [programID]);

    const onFinishFailed = (e) => {
        console.log("Failed:", e);
    };

    const handleProceed = () => {
        const allValues = form.getFieldsValue();
        const data = {
            programID,
            opportunityID: opportunityId,
            application: "Y",
            impactApproach: {
                objectives: opportunity?.impactApproach?.objectives?.map((objective) => ({
                    themeName: objective?.themeName,
                    name: objective?.name,
                    objectiveReportType: "application",
                    objectiveID: objective?.objectiveID,
                    themeID: objective?.themeID,
                    objectivesOutcome: (objective?.objectivesOutcome || []).map(outcome => ({
                        name: outcome.name,
                        outcomeApproach: allValues?.[`outcomeApproach-${objective?.name}-${outcome.name}`] || '',
                        outcomeReportType: "application",
                        objectiveID: objective?.objectiveID,
                    })),
                    objectiveUNSDG: objective?.objectiveUNSDG || [],
                })),
            },
        };
        dispatch(toggleSpinner(true));
        dispatch(editOpportunity(data))
    };

    const handleSaveAndExit = () => {
        setSavedClicked(true);
        setTimeout(() => {
            form.submit();
            dispatch(toggleSpinner(false));
            localStorage.removeItem('programReviewDetails');
            navigate(`/impact-maker/applications/${programID}/${opportunityId}`);
        }, 300);
    };

    const handlePrevious = () => {
        navigate("/impact-maker/applications/create/impact-opportunity-custom");
    };


    const countWords = (text) => {
        return text?.trim()?.split(/\s+/).filter(word => word.length > 0).length;
    };

    const handleTextChange = (name) => (e) => {
        const text = e.target.value;
        setTextAreas(prev => ({ ...prev, [name]: text }));
        form.setFieldsValue({ [name]: text });
    };

    return (
        <div className={baseClassName}>
            <Steps
                current={2}
                items={[
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_1" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>
                            {intl.formatMessage({ id: "about_your_project" })}
                        </StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_2" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>
                            {intl.formatMessage({ id: "your_request" })}
                        </StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_3" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3c" className='mainTitle'>
                            {intl.formatMessage({ id: "planned_impact_title" })}
                        </StyledText>,
                    },
                    {
                        title: <StyledText as="p" variant="H3">
                            {intl.formatMessage({ id: "step_4" })}
                        </StyledText>,
                        description: <StyledText as="p" variant="B3" className='mainTitle'>
                            {intl.formatMessage({ id: "award_criteria" })}
                        </StyledText>,
                    },
                ]}
            />
            {showSpinner && (
                <div className="overlay">
                    <Spin className="spinner" size="large" spinning={showSpinner} />
                </div>
            )}
            <div className='contentContainer'>
                <div className='leftContainer'>
                    <Form
                        {...formItemLayout}
                        labelAlign="left"
                        form={form}
                        onFinish={handleProceed}
                        onFinishFailed={onFinishFailed}
                        className="formContainer"
                        scrollToFirstError
                    >
                        <StyledText as="p" variant="B2">
                            {intl.formatMessage({ id: "how_will_you_achieve_these_outcomes" })}
                        </StyledText>
                        {opportunity?.impactApproach?.objectives?.map(el => (
                            <div key={el.name}>
                                <div className='checkboxGroup'>
                                    <StyledText as="p" variant="B3e">
                                        {el.name}
                                    </StyledText>
                                    <div className='objectiveUNSDGImagesContainer'>
                                        {outcomeUNSDGImages
                                            ?.filter(im => el.objectiveUNSDG?.includes(im.key))
                                            ?.map(im => (
                                                <Avatar shape="square" key={im.key} src={im.image} />
                                            ))}
                                    </div>
                                </div>
                                {el?.objectivesOutcome?.map((it) => (
                                    <Fragment key={`outcomeApproach-${el.name}-${it.name}`}>
                                        <div style={{ display: 'flex', gap: '5px', marginBottom: '15px' }}>
                                        <StyledText as="p" variant="B3d" className='mainSubTitle'>
                                        {intl.formatMessage({ id: "outcome_title" })}
                                        </StyledText>
                                            <StyledText as="p" variant="B3" className='mainSubTitle'>
                                            {it.name}
                                        </StyledText>
                                        </div>
                                        <StyledText as="p" variant="B3c" className='question'>
                                            {intl.formatMessage({ id: "how_will_you_achieve_this_outcome" })}
                                        </StyledText>
                                        <Form.Item name={`outcomeApproach-${el.name}-${it.name}`} className='textArea formItem'
                                            rules={[{ required: true, message: 'Outcome name is required' },
                                            {
                                                validator: (_, value) => {
                                                    const words = value?.trim().split(/\s+/).filter((word) => word.length > 0) || [];
                                                    if (words.length > 25) {
                                                        return Promise.reject(new Error('Word limit exceeded (Max 25 words)'));
                                                    }
                                                    return Promise.resolve();
                                                }
                                            }
                                            ]}>
                                            <TextArea
                                                rows={2}
                                                placeholder={intl.formatMessage({ id: "enter_description" })}
                                                value={textAreas[`outcomeApproach-${el.name}-${it.name}`] || ''}
                                                onChange={handleTextChange(`outcomeApproach-${el.name}-${it.name}`)}
                                            />
                                        </Form.Item>
                                        <div className={`wordCount ${countWords(textAreas[`outcomeApproach-${el.name}-${it.name}`] || '') > 25 ? 'error' : ''}`}>
                                            {countWords(textAreas[`outcomeApproach-${el.name}-${it.name}`] || '')} / 25 words
                                        </div>
                                    </Fragment>
                                ))}
                            </div>
                        ))}
                        <div className='buttonContainer'>
                            <Divider />
                            <div className='buttonContentContainer'>
                                <div className='nextAndPreviousContainer'>
                                    <Button variant="secondary" type="button" onClick={handlePrevious}>
                                        {intl.formatMessage({ id: "previous" })}
                                    </Button>
                                    <Button variant="primary" htmlType="submit">
                                        {intl.formatMessage({ id: "next" })}
                                    </Button>
                                </div>
                                <div className="saveAndExitButton">
                                    <Button variant="secondary" htmlType="button" onClick={handleSaveAndExit}>
                                        {intl.formatMessage({ id: "save_n_exit" })}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className='tipsContainer'>
                    <div className='titleContainer'>
                        <Avatar src={lightbulb} />
                        <StyledText as="p" variant="H1">
                            {intl.formatMessage({ id: "tips" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3d">
                            {intl.formatMessage({ id: "what_is_an_outcome" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "an_outcome_is_the_change_you_hope_to_see_as_a_result_of_your_project_below_are_some_examples" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "objective_protect_and_improve_the_local_environment" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "outcome_improve_fish_populations_through_river_restoration" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "objective_create_and_improve_local_amenities" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "objective_engage_the_local_community" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "outcome_reduce_isolation_and_loneliness_in_older_people" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B2">
                            {intl.formatMessage({ id: "how_will_you_achieve_these_outcomes" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "briefly_describe_your_approach_to_achieving_the_outcomes" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "below_are_some_examples" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "objective_protect_and_improve_the_local_environment" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "outcome_improve_fish_populations_through_river_restoration" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "we_will_remove_excess_silt" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "objective_create_and_improve_local_amenities" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "outcome_improve_the_energy_efficiency_of_the_village_hall_with_new_windows" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "we_will_replace_our_old_windows_with_triple_glazed_windows" })}
                        </StyledText>
                    </div>
                    <div>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "objective_engage_the_local_community" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "outcome_reduce_isolation_and_loneliness_in_older_people" })}
                        </StyledText>
                        <StyledText as="p" variant="B3">
                            {intl.formatMessage({ id: "we_will_run_weekly_workshops_bringing_older_people_together" })}
                        </StyledText>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default styled(CharityImpactProgram)`
&.charityImpactProgram{
    background: white;
    display: flex;
    padding: 20px;
    margin-top: 50px;
    flex-direction: column;
    justify-content: space-between;
    .ant-form{
        width: 50vw;
    }
    .contentContainer{
        display: flex;
        padding: 20px;
        justify-content: space-between;
        min-height: 60vh;
        padding-bottom: 60px;
        overflow-y: auto;
    }
    .mainSubTitle{
        margin-bottom: 5px;
    }
    .overlay {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1000;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.45);
        }
            .spinner {
            z-index: 2000;
            margin: auto;
            left: 50%;
            right: 50%;
            position: absolute;
            bottom: 50%;
        }
    .mainTitle{
        margin-bottom: 20px;
    }
    .formItemTextFieldPart{
        margin-bottom: 5px !important;
        width: 800px;
        .ant-form-item-control{
            width: 300px;
        }
    }
    .leftContainer{
        display: flex;
        width: 50vw;
    }
    .formContainer{
        display: flex;
        gap: 20px;
        flex-direction: column;
    }
    }

    .outcomeUNSDGImagesContainer{
        display: flex;
        gap: 20px;
        .ant-avatar{
            border-radius: 0 !important;
            height: 50px !important;
            width: 50px !important;
        }
    }
    .wordCount{
        text-align: right;
        margin-top: -20px;
        &.error{
            color: red;
            margin-top: -45px;
        }
    }

    .checkboxGroup{
        display: flex;
        flex-direction: column;
        gap: 10px;
        .objectiveUNSDGImagesContainer{
            display: flex;
            gap: 20px;
            margin-bottom: 12px;
            .ant-avatar{
                border-radius: 0 !important;
                height: 50px !important;
                width: 50px !important;
            }
        }
    }

    .question{ 
        margin-bottom: 10px;
    }

    .buttonContainer{
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        position: fixed;
        width: 100%;
        bottom: 0px;
        background: white;
        margin-left: -100px;
        .buttonContentContainer{
            display: flex;
            justify-content: center;
            width: 100%;
            position: relative;
            .saveAndExitButton{
                position: absolute;
                right: 0;
                margin-bottom: 15px;
            }
            .nextAndPreviousContainer{
                display: flex;
                gap: 20px;
                margin-bottom: 15px;
            }
        }
    }
    .tipsContainer{
    background: #D7FEFB;
    border: 1px solid #04ac9c;
    padding: 20px;
    border-radius: 10px;
    width: max-content;
    height: max-content;
    display: flex;
    flex-direction: column;
    gap: 15px;
    .titleContainer {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        gap: 10px;
    }
  }
}
`;
